import React from "react";
import Icon from "../Icon";

export default (props) => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M32 9.815V24a2 2 0 01-2 2H2a2 2 0 01-2-2V9.818l.402.276c9.15 6.26 11.732 7.615 15.424 7.655l.174.001h.164c3.535-.037 6.046-1.273 14.26-6.855l1.575-1.08zM30 3a2 2 0 012 2v1.18l-1.266.87c-9.187 6.306-11.657 7.66-14.6 7.7h-.266C13.1 14.712 10.75 13.513 2.84 8.126L0 6.178 0 5a2 2 0 012-2h28z"
      stroke="none"
    />
  </Icon>
);
